import React from 'react';
import { StyleSheet, View } from 'react-native';
import TimezoneSelect from 'react-timezone-select';
import { LabeledComponent } from './LabeledComponent';
import { theme } from '../theme';
import { NARROW_INPUT_FONT_SIZE, useIsNarrowForm, } from '../intakeForm/ResponsiveFormContext';
const timezoneStyles = {
    control: (provided, state) => ({
        ...provided,
        fontFamily: 'Basel Grotesk Regular, sans-serif',
        fontSize: 12,
        borderRadius: 12,
        borderSize: 2,
        borderColor: theme.colors.textTertiary,
        boxShadow: 'none',
        outline: state.isFocused
            ? `3px solid ${theme.colors.controlFocusRing}`
            : 'none',
        outlineOffset: '1px',
        backgroundColor: theme.colors.surfaceElevated,
        zIndex: 10,
        width: '100%', // Ensure it takes full width inside the container
        minWidth: 300, // Minimum width for readability
        maxWidth: 500, // Prevent excessive expansion
        '&:hover': {
            borderColor: theme.colors.textTertiary, // Keeps it the same
        },
    }),
    menu: provided => ({
        ...provided,
        width: '100%',
        borderRadius: 10,
        overflow: 'hidden',
        zIndex: 9999, // Ensure dropdown appears above other elements
        position: 'absolute', // Keeps dropdown separate from flow
    }),
    menuPortal: provided => ({
        ...provided,
        zIndex: 9999, // Ensures portal is at the highest level
    }),
    option: provided => ({
        ...provided,
        fontFamily: 'Basel Grotesk Regular, sans-serif',
        fontSize: 12,
        padding: 8,
        whiteSpace: 'nowrap', // Prevents line breaks
        overflow: 'hidden', // Hides overflowed text
        textOverflow: 'ellipsis', // Adds "..." for overflowed text
    }),
    singleValue: provided => ({
        ...provided,
        color: theme.colors.textPrimary,
        fontFamily: 'Basel Grotesk Regular, sans-serif',
        fontSize: 12,
    }),
    placeholder: provided => ({
        ...provided,
        fontSize: 14,
    }),
};
/**
 * Phone-sized public sign-up only: no 300px minimum width, and 16px text so
 * iOS Safari doesn't zoom in when the select's search input gets focus.
 */
const narrowTimezoneStyles = {
    ...timezoneStyles,
    control: (provided, state) => ({
        ...timezoneStyles.control(provided, state),
        fontSize: NARROW_INPUT_FONT_SIZE,
        minWidth: 0,
    }),
    option: (provided, state) => ({
        ...timezoneStyles.option(provided, state),
        fontSize: NARROW_INPUT_FONT_SIZE,
        whiteSpace: 'normal',
    }),
    singleValue: (provided, state) => ({
        ...timezoneStyles.singleValue(provided, state),
        fontSize: NARROW_INPUT_FONT_SIZE,
    }),
    placeholder: (provided, state) => ({
        ...timezoneStyles.placeholder(provided, state),
        fontSize: NARROW_INPUT_FONT_SIZE,
    }),
    input: provided => ({
        ...provided,
        fontSize: NARROW_INPUT_FONT_SIZE,
    }),
};
export const TimezoneSelector = ({ values, readOnly, setFieldValue }) => {
    const narrow = useIsNarrowForm();
    return (<LabeledComponent label="Time zone" width={500} readOnly={readOnly}>
      <View style={[styles.timezoneContainer, narrow && styles.timezoneNarrow]}>
        <TimezoneSelect labelStyle="abbrev" styles={narrow ? narrowTimezoneStyles : timezoneStyles} isDisabled={readOnly} value={values.timezone} onChange={(tz) => setFieldValue('timezone', tz.value)} menuPortalTarget={typeof document !== 'undefined' ? document.body : null} // Ensures it works only in web
    />
      </View>
    </LabeledComponent>);
};
const styles = StyleSheet.create({
    timezoneContainer: {
        marginTop: 10,
    },
    timezoneNarrow: {
        marginHorizontal: 10,
    },
});
